import { InfoMessage } from '@eika/attention-message';
import { WarningCard } from '@eika/card';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { RichIconTypes } from '@eika/rich-icon';
import { useLinks } from '@hooks/use-links';
import { useTranslation } from '@translations';
import './no-children-warning.scss';

export const NoChildrenWarning = () => {
    const { listOfChildren } = useTranslation();
    const { noChildrenHeader, noChildrenIngress } = listOfChildren;

    return (
        <div className="no-children-warning">
            <WarningCard icon={RichIconTypes.UNDRENDE} title={noChildrenHeader} data-testid="no-children-found">
                <span role="alert">{noChildrenIngress}</span>
            </WarningCard>
            <Tip />
        </div>
    );
};

const Tip = () => {
    const { listOfChildren, smartspar, tip } = useTranslation();
    const { smartspar: smartsparLink } = useLinks();

    const SmartsparLinkButton = () => (
        <Link
            href={smartsparLink.url}
            linkType="button-negative"
            size="small"
            target="_blank"
            iconOnRightSide
            icon={IconTypes.EKSTERN_24}
        >
            {smartspar.readMore}
        </Link>
    );

    return (
        <InfoMessage
            header={tip}
            text={listOfChildren.noChildrenTips}
            icon={IconTypes.LYSPAERE_24}
            clickableItem={<SmartsparLinkButton />}
        />
    );
};
